import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import './deleteActivity.css'; // Import the CSS file

const DeleteActivity = ({  onConfirm, onCancel ,disabled}) => {
   
    return (
        <Dialog
            open={true}
            onClose={onCancel}
            aria-labelledby="delete-dialog-title"
            className='deleteActivityDialog'
        >
            <div  className="deleteActivitydialogTitle">Confirm Deletion</div>
            <DialogContent className="deleteActivitydialogContent">
                <p>Are you sure you want to delete this activity?</p>
            </DialogContent>
            <DialogActions className="deleteActivitydialogActions">
                {!disabled && <Button onClick={onCancel} className="deleteActivityButtonCancel">
                    Cancel
                </Button>}
                <Button  disabled={disabled} onClick={onConfirm} className="deleteActivityButtonConfirm" variant="contained">
                    Confirm Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteActivity;
